import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';

import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { bootstrapApplication } from '@angular/platform-browser';
import { transformEventTitle } from './app/services/sentry/sentry.service';

const isLocalhost = ['localhost', '127.0.0.1']?.includes(window?.location?.hostname);

if (!isLocalhost) {
  Sentry.init({
    dsn: "https://d973c6601fd6df2fd9c4b7c302c5f269@o1070489.ingest.us.sentry.io/4510861527220224",
    environment: environment.type,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: environment.production ? 0.1 : 1.0,
    tracePropagationTargets: ["localhost", /^https:\/\/.*\.sarasanalytics\.com/],
    replaysSessionSampleRate: environment.production ? 0.1 : 1.0,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event) {
      try {
        return transformEventTitle(event);
      } catch (error) {
        return event;
      }
    },
  });
}

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));
